import { Controller } from "@hotwired/stimulus"
import {init_global_js} from "../packs/global"
import {init_bootstrap} from "../packs/global_bootstrap"
import {init_sort} from "../packs/sort"

export default class extends Controller {

  connect() {
    // console.log("Hello, Global activation!", this.element);

    init_global_js(this.element);
    init_bootstrap(this.element);
    init_sort(this.element);
  }
}
